import { useLocation } from "react-router-dom";
import charly from "../assets/images/charly.svg";
import charly2 from "../assets/images/charly2.svg";
import wave from "../assets/images/wave.svg";

const BodyAlt = ({ children }) => {
  return (
    <main className="auth-body-container">
      <div className="w-100">{children}</div>
      <style>{`
        .auth-body-container {
          min-height: 100vh;
          display: flex;
          align-items: flex-start;
          padding: 0;
          background-color: var(--pastel-blue);
          background-image: radial-gradient(circle at 20% 30%, var(--pastel-pink) 0%, transparent 40%),
                            radial-gradient(circle at 80% 70%, var(--pastel-green) 0%, transparent 40%);
          overflow-x: hidden;
        }
      `}</style>
    </main>
  );
};

export default BodyAlt;
